/**
 * The "Model Context Protocol" labelled border box connected to a description
 * snippet — ported from the Figma export (dev-mcp hero/McpBadge).
 *
 * Mobile : bordered badge → vertical red stem → description (stacked)
 * Desktop: bordered badge → horizontal indigo line + circle dot → description
 */
export default function McpBadgeConnector({ label, description }) {
  return (
    <>
      {/* Mobile: stacked */}
      <div className="md:hidden">
        <div className="inline-flex items-center justify-center border-2 border-[#e45d59] rounded-[5px] h-[35px] px-4 min-w-[210px]">
          <span className="text-white text-[14px] font-medium whitespace-nowrap">
            {label}
          </span>
        </div>
        <div className="ml-[16px] min-[478px]:ml-[100px] flex w-[10px] flex-col items-center">
          <div className="w-px h-[20px] bg-[#E45D59]" />
          <div className="w-[10px] h-[10px] rounded-full bg-[#E45D59]" />
        </div>
        <p className="mt-[5px] text-white text-[14px] font-medium leading-[1.3] max-w-[322px]">
          {description}
        </p>
      </div>

      {/* Desktop: horizontal row */}
      <div className="hidden md:flex items-center gap-0">
        <div className="inline-flex items-center justify-center border-2 xl:border-[1.75px] border-[#e45d59] rounded-[5px] h-[35px] px-3 min-w-[201px] shrink-0">
          <span className="text-white text-[14px] font-medium whitespace-nowrap">
            {label}
          </span>
        </div>

        <div className="flex items-center w-[124px] shrink-0">
          <div className="flex-1 h-px bg-[#59649F]" />
          <div className="w-[10px] h-[10px] rounded-full bg-[#59649F] shrink-0" />
        </div>

        <p className="text-white text-[14px] font-medium leading-[1.3] ml-4 max-w-[322px]">
          {description}
        </p>
      </div>
    </>
  );
}
